import React, { useState, useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import { _T, C, CSS } from '../../shared/theme';

const BASE_PROGRAMS = [
  {
    title:       { nl: 'Slaapherstelprogramma', en: 'Sleep Recovery Program' },
    description: { nl: 'Evidence-based 8-weken programma om slaapkwaliteit en -duur te verbeteren.', en: 'Evidence-based 8-week program to improve sleep quality and duration.' },
    weeks: 8,
    tasks: [
      { week: 1, nl: ['Stel een vaste bedtijd in', 'Geen schermen 1 uur voor het slapen', 'Slaap bijhouden vanavond'], en: ['Set a fixed bedtime', 'No screens 1 hour before bed', 'Track sleep tonight'] },
      { week: 2, nl: ['Koude douche voor het slapen', 'Beperk cafeïne na 14:00', 'Maak een slaproutine'], en: ['Cold shower before bed', 'Limit caffeine after 2pm', 'Create a wind-down routine'] },
      { week: 3, nl: ['Slaapkamertemperatuur optimaliseren (16-18°C)', '4-7-8 ademhaling proberen', 'Streef naar 7,5 uur'], en: ['Optimize bedroom temperature (16-18°C)', 'Try 4-7-8 breathing', 'Aim for 7.5 hours'] },
      { week: 4, nl: ['Geen alcohol deze week', 'Ochtendzonlicht binnen 30 min na het opstaan', 'Midweekse check-in'], en: ['No alcohol this week', 'Morning sunlight within 30 min of waking', 'Mid-week check-in'] },
      { week: 5, nl: ['Progressieve spierontspanning voor het slapen', 'Slaapkamer alleen voor slapen', 'Energieniveaus bijhouden'], en: ['Progressive muscle relaxation before bed', 'Keep bedroom only for sleep', 'Track energy levels'] },
      { week: 6, nl: ['Dutjes vermijden langer dan 20 min', 'Journalen voor het slapen', 'Slaaplogtrends bekijken'], en: ['Avoid naps longer than 20 min', 'Journaling before sleep', 'Review sleep log trends'] },
      { week: 7, nl: ['Consistente wektijd in het weekend', 'Lichte avondwandeling', 'Topslaapasstoorders identificeren'], en: ['Maintain consistent wake time on weekends', 'Light evening walk', 'Identify top sleep disruptors'] },
      { week: 8, nl: ['Bouw je permanente slaproutine op', 'Deel successen met manager', 'Stel volgend doel in'], en: ['Build your permanent sleep routine', 'Share wins with manager', 'Set next goal'] },
    ],
  },
  {
    title:       { nl: 'Stress & Veerkrachtprogramma', en: 'Stress & Resilience Program' },
    description: { nl: 'Bouw mentale veerkracht op met dagelijkse micro-gewoontes over 8 weken.', en: 'Build mental resilience with daily micro-habits over 8 weeks.' },
    weeks: 8,
    tasks: [
      { week: 1, nl: ['5 min ochtendmeditatie', '3 stressoren identificeren deze week', 'Neem een echte lunchpauze'], en: ['5-min morning mindfulness', 'Identify 3 stressors this week', 'Take a real lunch break'] },
      { week: 2, nl: ['Boxademhaling bij stressvolle momenten', 'Één uur digitale detox per dag', 'Dagelijkse dankbaarheden noteren'], en: ['Box breathing during stressful moments', 'One digital detox hour per day', 'List daily gratitudes'] },
      { week: 3, nl: ['Korte wandeling elke 90 minuten', 'Nee zeggen tegen één niet-essentiële taak', 'Contact met een collega'], en: ['Short walk every 90 minutes', 'Say no to one non-essential task', 'Connect with a colleague'] },
      { week: 4, nl: ['Koude blootstelling (gezicht in koud water)', 'Maximaal 3 taken per dag prioriteren', 'Stressniveaus controleren'], en: ['Cold exposure (face in cold water)', 'Prioritize 3 tasks max per day', 'Check stress levels'] },
      { week: 5, nl: ['Yoga of stretching (15 min)', 'Focusblokken met één taak tegelijk', 'Praat met manager indien nodig'], en: ['Yoga or stretching (15 min)', 'Single-tasking focus blocks', 'Talk to manager if needed'] },
      { week: 6, nl: ['Creatieve bezigheid (tekenen, koken, schrijven)', 'Bekijk wat energie kost', 'Grenzen stellen controleren'], en: ['Creative outlet (draw, cook, write)', 'Review what drains your energy', 'Set boundaries check'] },
      { week: 7, nl: ['Assertieve communicatie oefenen', 'Peer support gesprek', 'Copingstrategieën herzien'], en: ['Practice assertive communication', 'Peer support conversation', 'Revisit coping strategies'] },
      { week: 8, nl: ['Reflecteren op veerkrachtsgroei', 'Schrijf je stressresponsplan', 'Vier vooruitgang'], en: ['Reflect on resilience growth', 'Write your stress response plan', 'Celebrate progress'] },
    ],
  },
  {
    title:       { nl: 'Energie & Bewegingsprogramma', en: 'Energy & Movement Program' },
    description: { nl: 'Boost dagelijkse energie met beweging, voeding en herstelgewoontes.', en: 'Boost daily energy with movement, nutrition, and recovery habits.' },
    weeks: 8,
    tasks: [
      { week: 1, nl: ['10 min ochtendbeweging', 'Drink 2L water per dag', 'Trap nemen in plaats van lift'], en: ['10-min morning movement', 'Drink 2L water per day', 'Take stairs instead of elevator'] },
      { week: 2, nl: ['15 min lunchwandeling', 'Elke dag ontbijten', 'Energie bijhouden 1-10 aan einde dag'], en: ['15-min lunchtime walk', 'Eat breakfast every day', 'Track energy 1-10 at end of day'] },
      { week: 3, nl: ['Bureaurek elke uur', 'Groenten bij elke maaltijd', 'Avondwandeling'], en: ['Desk stretching every hour', 'Add vegetables to every meal', 'Evening wind-down walk'] },
      { week: 4, nl: ['Lichaamsgewichttraining (20 min)', 'Suikerinname verminderen deze week', 'Houding aan bureau controleren'], en: ['Bodyweight workout (20 min)', 'Reduce sugar intake this week', 'Check posture at desk'] },
      { week: 5, nl: ['Actieve hobby vinden', 'Maaltijden voorbereiden voor de week', 'Staand bellen'], en: ['Find an active hobby', 'Meal prep for the week', 'Stand while on calls'] },
      { week: 6, nl: ['Training verhogen naar 25 min', 'Eiwitinname bijhouden', 'Actief woon-werkverkeer indien mogelijk'], en: ['Increase workout to 25 min', 'Track protein intake', 'Active commute if possible'] },
      { week: 7, nl: ['Nieuwe sport of les proberen', 'Bewust eten — geen schermen tijdens maaltijden', 'Rustdag met intentie'], en: ['Try a new sport or class', 'Mindful eating — no screens during meals', 'Rest day with intention'] },
      { week: 8, nl: ['Bouw je duurzame bewegingsroutine op', 'Stel volgend fitnessdoel in', 'Deel energieverbeteringen'], en: ['Build your sustainable movement routine', 'Set next fitness goal', 'Share energy improvements'] },
    ],
  },
];

// ── Exercise type detection from task text ─────────────────────────────────────
function detectExercise(taskText) {
  const t = taskText.toLowerCase();
  if (/adem|breath|4-7-8|box.?adem/.test(t))
    return { type: 'breathing', icon: '🫁', nl: 'Ademhalingsoefening', en: 'Breathing Exercise' };
  if (/meditati|meditat|mindful/.test(t))
    return { type: 'breathing', icon: '🧘', nl: 'Mindfulness moment', en: 'Mindfulness Moment' };
  if (/wandel|walk|stap|avondwandel|lunchwandel|evening.walk|lunchtime.walk/.test(t))
    return { type: 'timer', icon: '🚶', nl: 'Wandeltimer', en: 'Walk Timer', duration: 300, label_nl: '5 min wandeling', label_en: '5 min walk' };
  if (/oefening|workout|sport.*les|les.*sport|ochtendbeweging|beweging.*min|bodyweight|training.*min/.test(t))
    return { type: 'timer', icon: '💪', nl: 'Oefen-timer', en: 'Workout Timer', duration: 600, label_nl: '10 min oefening', label_en: '10 min workout' };
  if (/rek|yoga|stretch|spieront|progressive.muscle/.test(t))
    return { type: 'timer', icon: '🤸', nl: 'Rektimer', en: 'Stretch Timer', duration: 300, label_nl: '5 min stretchen', label_en: '5 min stretching' };
  if (/koud|cold/.test(t))
    return { type: 'timer', icon: '🧊', nl: 'Koude blootstelling', en: 'Cold Exposure', duration: 30, label_nl: '30 sec koud water', label_en: '30 sec cold water' };
  if (/journal|schrijf.*ting|reflecteer|reflect|write.*stress|stress.*plan/.test(t))
    return { type: 'journal', icon: '📝', nl: 'Journaling', en: 'Journaling', prompt_nl: 'Schrijf vrij over je gedachten en gevoelens van vandaag...', prompt_en: 'Write freely about your thoughts and feelings today...' };
  if (/water|drink.*(dag|per day)/.test(t))
    return { type: 'acknowledge', icon: '💧', nl: 'Drinkwater', en: 'Drink Water', desc_nl: 'Pak een glas water (250ml) en drink het op. Je lichaam zal je dankbaar zijn!', desc_en: 'Get a glass of water (250ml) and drink it up. Your body will thank you!' };
  return { type: 'acknowledge', icon: '✅', nl: 'Taak bevestigen', en: 'Confirm Task', desc_nl: 'Bevestig dat je deze taak vandaag hebt voltooid.', desc_en: 'Confirm that you have completed this task today.' };
}

// ── Breathing mini exercise ────────────────────────────────────────────────────
function BreathingMini({ nl, onDone }) {
  const SEQ = [
    { key: 'in',  sec: 4, nl: 'Inademen',   en: 'Inhale',  scale: 1.3 },
    { key: 'h1',  sec: 4, nl: 'Vasthouden', en: 'Hold',    scale: 1.3 },
    { key: 'out', sec: 4, nl: 'Uitademen',  en: 'Exhale',  scale: 1.0 },
    { key: 'h2',  sec: 4, nl: 'Pauze',      en: 'Pause',   scale: 1.0 },
  ];
  const CYCLE = 16;
  const ROUNDS = 3;
  const TOTAL  = CYCLE * ROUNDS;

  const [elapsed, setElapsed] = useState(0);
  const doneRef = useRef(false);

  useEffect(() => {
    const t = setInterval(() => {
      setElapsed(e => {
        const n = e + 1;
        if (n >= TOTAL && !doneRef.current) {
          doneRef.current = true;
          clearInterval(t);
          setTimeout(onDone, 600);
        }
        return Math.min(n, TOTAL);
      });
    }, 1000);
    return () => clearInterval(t);
  }, []); // eslint-disable-line

  const cyclePos = elapsed % CYCLE;
  let acc = 0, phaseObj = SEQ[0], inPhase = 0;
  for (const p of SEQ) {
    if (cyclePos < acc + p.sec) { phaseObj = p; inPhase = cyclePos - acc; break; }
    acc += p.sec;
  }
  const remaining = phaseObj.sec - inPhase;
  const round     = Math.min(Math.floor(elapsed / CYCLE) + 1, ROUNDS);

  return (
    <div style={{ textAlign: 'center', padding: '8px 0' }}>
      <div style={{ color: C.silver, fontSize: 11, marginBottom: 14 }}>
        {nl ? `Ronde ${round} / ${ROUNDS}` : `Round ${round} / ${ROUNDS}`}
      </div>
      <div style={{
        width: 120, height: 120, borderRadius: '50%',
        background: 'radial-gradient(circle, #2A9E8233 0%, #2A9E8211 100%)',
        border: '2.5px solid #2A9E8255',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        margin: '0 auto 16px',
        transform: `scale(${phaseObj.scale})`,
        transition: `transform ${phaseObj.sec}s ease-in-out`,
        boxShadow: `0 0 ${phaseObj.scale > 1 ? '30px' : '10px'} #2A9E8222`,
      }}>
        <span style={{ fontSize: 38 }}>🫁</span>
      </div>
      <div style={{ color: 'white', fontSize: 20, fontWeight: 700, marginBottom: 4 }}>
        {nl ? phaseObj.nl : phaseObj.en}
      </div>
      <div style={{ color: _T.accent, fontSize: 30, fontWeight: 700 }}>{remaining}</div>
    </div>
  );
}

// ── Timer mini exercise ────────────────────────────────────────────────────────
function TimerMini({ exercise, nl, onDone }) {
  const [sec, setSec]         = useState(exercise.duration);
  const [running, setRunning] = useState(false);
  const doneRef = useRef(false);

  useEffect(() => {
    if (!running || sec <= 0) return;
    const t = setTimeout(() => {
      setSec(s => {
        const n = Math.max(0, s - 1);
        if (n === 0 && !doneRef.current) { doneRef.current = true; setTimeout(onDone, 400); }
        return n;
      });
    }, 1000);
    return () => clearTimeout(t);
  }, [running, sec]); // eslint-disable-line

  const pct  = ((exercise.duration - sec) / exercise.duration) * 100;
  const mins = Math.floor(sec / 60);
  const secs = sec % 60;
  const R    = 50, CXY = 60;
  const circ = 2 * Math.PI * R;

  return (
    <div style={{ textAlign: 'center', padding: '8px 0' }}>
      <div style={{ color: 'white', fontSize: 14, fontWeight: 600, marginBottom: 14 }}>
        {nl ? exercise.label_nl : exercise.label_en}
      </div>
      <svg width={130} height={130} style={{ margin: '0 auto 16px', display: 'block' }}>
        <circle cx={CXY} cy={CXY} r={R} fill="none" stroke="#ffffff0d" strokeWidth={10} />
        <circle cx={CXY} cy={CXY} r={R} fill="none" stroke={_T.grad1} strokeWidth={10}
          strokeDasharray={circ}
          strokeDashoffset={circ * (1 - pct / 100)}
          strokeLinecap="round"
          transform={`rotate(-90 ${CXY} ${CXY})`}
          style={{ transition: 'stroke-dashoffset 0.8s ease' }}
        />
        <text x={CXY} y={CXY - 6} textAnchor="middle" fill="white" fontSize={22} fontWeight="700">
          {mins}:{String(secs).padStart(2, '0')}
        </text>
        <text x={CXY} y={CXY + 15} textAnchor="middle" fill="#ffffff66" fontSize={14}>
          {exercise.icon}
        </text>
      </svg>
      {!running ? (
        <button onClick={() => setRunning(true)}
          style={{ background: `linear-gradient(135deg,${_T.grad1},${_T.grad2})`, border: 'none', borderRadius: 12, color: '#0a1220', fontWeight: 700, fontSize: 14, padding: '12px 32px', cursor: 'pointer' }}>
          {nl ? 'Starten →' : 'Start →'}
        </button>
      ) : sec > 0 ? (
        <button onClick={() => { doneRef.current = true; onDone(); }}
          style={{ background: 'none', border: `1px solid ${_T.cardBorderBot}`, borderRadius: 10, color: C.silver, fontSize: 12, padding: '8px 20px', cursor: 'pointer' }}>
          {nl ? 'Overslaan' : 'Skip'}
        </button>
      ) : null}
    </div>
  );
}

// ── Journal mini exercise ──────────────────────────────────────────────────────
function JournalMini({ exercise, nl, onDone }) {
  const [text, setText] = useState('');
  const ok = text.trim().length >= 20;
  return (
    <div>
      <div style={{ fontSize: 36, textAlign: 'center', marginBottom: 8 }}>{exercise.icon}</div>
      <div style={{ color: C.silver, fontSize: 12, marginBottom: 10, lineHeight: 1.6, textAlign: 'center' }}>
        {nl ? exercise.prompt_nl : exercise.prompt_en}
      </div>
      <textarea
        value={text} onChange={e => setText(e.target.value)}
        placeholder={nl ? 'Begin met schrijven... (min. 20 tekens)' : 'Start writing... (min. 20 chars)'}
        rows={5}
        style={{ width: '100%', background: '#080e1a', border: `1px solid ${_T.cardBorderBot}`, borderRadius: 10, color: 'white', fontSize: 13, padding: '10px 12px', resize: 'none', boxSizing: 'border-box', fontFamily: 'inherit', lineHeight: 1.5, outline: 'none' }}
      />
      <button onClick={onDone} disabled={!ok}
        style={{ marginTop: 10, width: '100%', background: ok ? `linear-gradient(135deg,${_T.grad1},${_T.grad2})` : '#1a2438', border: 'none', borderRadius: 12, color: ok ? '#0a1220' : '#4a5568', fontSize: 14, fontWeight: 700, padding: '12px', cursor: ok ? 'pointer' : 'not-allowed', transition: 'all 0.2s' }}>
        {nl ? 'Klaar ✓' : 'Done ✓'}
      </button>
    </div>
  );
}

// ── Acknowledge mini exercise ──────────────────────────────────────────────────
function AcknowledgeMini({ exercise, nl, onDone }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 52, marginBottom: 10 }}>{exercise.icon}</div>
      <div style={{ color: C.silver, fontSize: 13, lineHeight: 1.7, marginBottom: 20 }}>
        {nl ? exercise.desc_nl : exercise.desc_en}
      </div>
      <button onClick={onDone}
        style={{ width: '100%', background: `linear-gradient(135deg,${_T.grad1},${_T.grad2})`, border: 'none', borderRadius: 12, color: '#0a1220', fontSize: 14, fontWeight: 700, padding: '14px', cursor: 'pointer' }}>
        {nl ? 'Gedaan! ✓' : 'Done! ✓'}
      </button>
    </div>
  );
}

// ── Mini exercise modal ────────────────────────────────────────────────────────
function MiniExerciseModal({ exercise, taskText, nl, onComplete, onCancel }) {
  const [phase, setPhase] = useState('intro');

  let content;
  if (phase === 'intro') {
    content = (
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 44, marginBottom: 8 }}>{exercise.icon}</div>
        <div style={{ color: 'white', fontSize: 15, fontWeight: 700, marginBottom: 8 }}>
          {nl ? exercise.nl : exercise.en}
        </div>
        <div style={{ color: C.silver, fontSize: 12, lineHeight: 1.6, marginBottom: 20 }}>
          {nl
            ? `Doe een korte oefening voordat je "${taskText}" afvinkt.`
            : `Complete a quick exercise before checking off "${taskText}".`}
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onCancel}
            style={{ flex: 1, background: 'none', border: `1px solid ${_T.cardBorderBot}`, borderRadius: 12, color: C.silver, fontSize: 13, padding: '11px', cursor: 'pointer' }}>
            {nl ? 'Overslaan' : 'Skip'}
          </button>
          <button onClick={() => setPhase('active')}
            style={{ flex: 2, background: `linear-gradient(135deg,${_T.grad1},${_T.grad2})`, border: 'none', borderRadius: 12, color: '#0a1220', fontSize: 14, fontWeight: 700, padding: '11px', cursor: 'pointer' }}>
            {nl ? 'Starten →' : 'Start →'}
          </button>
        </div>
      </div>
    );
  } else if (phase === 'active') {
    if (exercise.type === 'breathing')
      content = <BreathingMini nl={nl} onDone={() => setPhase('done')} />;
    else if (exercise.type === 'timer')
      content = <TimerMini exercise={exercise} nl={nl} onDone={() => setPhase('done')} />;
    else if (exercise.type === 'journal')
      content = <JournalMini exercise={exercise} nl={nl} onDone={() => setPhase('done')} />;
    else
      content = <AcknowledgeMini exercise={exercise} nl={nl} onDone={() => setPhase('done')} />;
  } else {
    content = (
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 52, marginBottom: 8 }}>🎉</div>
        <div style={{ color: '#4AC87A', fontSize: 18, fontWeight: 700, marginBottom: 6 }}>
          {nl ? 'Goed gedaan!' : 'Well done!'}
        </div>
        <div style={{ color: C.silver, fontSize: 12, marginBottom: 20 }}>
          {nl ? 'Oefening voltooid — taak wordt afgevinkt!' : 'Exercise complete — task checked off!'}
        </div>
        <button onClick={onComplete}
          style={{ width: '100%', background: 'linear-gradient(135deg,#4AC87A,#2fa85f)', border: 'none', borderRadius: 12, color: '#0a1220', fontSize: 14, fontWeight: 700, padding: '14px', cursor: 'pointer' }}>
          {nl ? 'Doorgaan ✓' : 'Continue ✓'}
        </button>
      </div>
    );
  }

  return ReactDOM.createPortal(
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 20 }}>
      <div style={{ background: '#0e1828', border: `1px solid ${_T.cardBorderBot}`, borderRadius: 20, padding: 24, width: '100%', maxWidth: 360, boxShadow: '0 20px 60px rgba(0,0,0,0.7)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: 9, color: _T.accent, fontWeight: 700, letterSpacing: 2 }}>
            {nl ? 'MINI OEFENING' : 'MINI EXERCISE'}
          </div>
          <button onClick={onCancel}
            style={{ background: 'none', border: 'none', color: C.silver, fontSize: 22, cursor: 'pointer', lineHeight: 1, padding: 4 }}>×</button>
        </div>
        {content}
      </div>
    </div>,
    document.body
  );
}

// ── Main component ─────────────────────────────────────────────────────────────
export default function BusinessProgramsScreen({ lang, businessId, currentUserId, role }) {
  const nl = lang === 'nl';
  const [programs, setPrograms]           = useState([]);
  const [loading, setLoading]             = useState(true);
  const [activeProgram, setActiveProgram] = useState(null);
  const [progress, setProgress]           = useState([]);
  const [myProgress, setMyProgress]       = useState(null);
  const [showTemplates, setShowTemplates] = useState(false);
  const [miniExModal, setMiniExModal]     = useState(null);

  const BASE    = process.env.REACT_APP_API_URL || '/api';
  const isAdmin = role === 'owner' || role === 'admin';

  const load = useCallback(() => {
    fetch(`${BASE}/businesses/${businessId}/programs`).then(r => r.json()).then(data => {
      if (Array.isArray(data)) setPrograms(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [BASE, businessId]);

  useEffect(() => { load(); }, [load]);

  const openProgram = (prog) => {
    setActiveProgram(prog);
    fetch(`${BASE}/businesses/${businessId}/programs/${prog.id}/progress`).then(r => r.json()).then(rows => {
      if (Array.isArray(rows)) {
        setProgress(rows);
        const mine = rows.find(r => r.user_id === currentUserId);
        setMyProgress(mine || { week: 1, completed_tasks: [] });
      }
    }).catch(() => setMyProgress({ week: 1, completed_tasks: [] }));
  };

  const logActivity = (task, programTitle) => {
    try {
      const key = `sl_biz_activity_${businessId}_${currentUserId}`;
      const log = JSON.parse(localStorage.getItem(key) || '[]');
      log.unshift({ task, program: programTitle, time: Date.now() });
      localStorage.setItem(key, JSON.stringify(log.slice(0, 200)));
    } catch {}
  };

  const toggleTask = (wi, ti) => {
    if (!myProgress) return;
    const key     = `${wi}-${ti}`;
    const current = myProgress.completed_tasks || [];
    const isAdding = !current.includes(key);
    const updated  = isAdding ? [...current, key] : current.filter(k => k !== key);
    setMyProgress(p => ({ ...p, completed_tasks: updated }));
    if (isAdding && activeProgram) {
      const taskText = (activeProgram.tasks?.[wi]?.items?.[ti]) || '';
      logActivity(taskText, activeProgram.title);
    }
    fetch(`${BASE}/businesses/${businessId}/programs/${activeProgram.id}/progress`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: currentUserId, week: myProgress.week || 1, completed_tasks: updated }),
    }).catch(() => {});
  };

  const handleTaskClick = (wi, ti, taskText) => {
    const key    = `${wi}-${ti}`;
    const isDone = (myProgress?.completed_tasks || []).includes(key);
    if (isDone) { toggleTask(wi, ti); return; }
    setMiniExModal({ wi, ti, task: taskText, exercise: detectExercise(taskText) });
  };

  const completeMiniExercise = () => {
    if (!miniExModal) return;
    const { wi, ti, task } = miniExModal;
    toggleTask(wi, ti);
    try {
      const hist = JSON.parse(localStorage.getItem('sl_ex_history') || '[]');
      hist.push({ id: `prog_${wi}_${ti}_${Date.now()}`, type: 'program_task', task, ts: Date.now() });
      localStorage.setItem('sl_ex_history', JSON.stringify(hist));
    } catch {}
    setMiniExModal(null);
  };

  const advanceWeek = () => {
    if (!myProgress || !activeProgram) return;
    const nextWeek = Math.min((myProgress.week || 1) + 1, activeProgram.weeks);
    setMyProgress(p => ({ ...p, week: nextWeek }));
    fetch(`${BASE}/businesses/${businessId}/programs/${activeProgram.id}/progress`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: currentUserId, week: nextWeek, completed_tasks: myProgress.completed_tasks || [] }),
    }).catch(() => {});
  };

  const createFromTemplate = (tpl) => {
    fetch(`${BASE}/businesses/${businessId}/programs`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title: nl ? tpl.title.nl : tpl.title.en, description: nl ? tpl.description.nl : tpl.description.en, weeks: tpl.weeks, tasks: tpl.tasks.map(w => ({ week: w.week, items: nl ? w.nl : w.en })) }),
    }).then(() => { setShowTemplates(false); load(); }).catch(() => {});
  };

  const deleteProgram = (id) => {
    if (!window.confirm(nl ? 'Dit programma verwijderen?' : 'Delete this program?')) return;
    fetch(`${BASE}/businesses/${businessId}/programs/${id}`, { method: 'DELETE' }).then(load).catch(() => {});
  };

  if (loading) return <div style={{ padding: 24, textAlign: 'center', color: C.silver, fontSize: 13 }}>...</div>;

  // ── Program detail ────────────────────────────────────────────────────────────
  if (activeProgram) {
    const tasks       = activeProgram.tasks || [];
    const currentWeek = myProgress?.week || 1;
    const completed   = myProgress?.completed_tasks || [];
    const totalTasks  = tasks.reduce((sum, w) => sum + (w.items?.length || 0), 0);
    const pct         = totalTasks > 0 ? Math.round((completed.length / totalTasks) * 100) : 0;

    return (
      <div style={{ padding: '0 0 32px' }}>
        <style>{CSS}</style>
        <button onClick={() => setActiveProgram(null)}
          style={{ background: 'none', border: 'none', color: _T.accent, fontSize: 14, cursor: 'pointer', padding: '0 0 12px' }}>
          ← {nl ? 'Terug' : 'Back'}
        </button>
        <div style={{ color: C.white, fontSize: 17, fontWeight: 700, marginBottom: 4 }}>{activeProgram.title}</div>
        <div style={{ color: C.silver, fontSize: 13, marginBottom: 16 }}>{activeProgram.description}</div>

        {/* Progress bar */}
        <div style={{ background: _T.bg3, borderRadius: 12, padding: 14, marginBottom: 14, border: `1px solid ${_T.cardBorderBot}` }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 8 }}>
            <span style={{ color: C.white, fontWeight: 600 }}>{nl ? 'Jouw voortgang' : 'Your progress'}</span>
            <span style={{ color: _T.accent, fontWeight: 600 }}>{pct}%</span>
          </div>
          <div style={{ background: _T.bg4, borderRadius: 6, height: 10 }}>
            <div style={{ width: `${pct}%`, height: '100%', background: `linear-gradient(90deg,${_T.grad1},${_T.grad2})`, borderRadius: 6, transition: 'width 0.3s' }} />
          </div>
          <div style={{ fontSize: 12, color: C.silver, marginTop: 6 }}>
            {nl ? 'Week' : 'Week'} {currentWeek} {nl ? 'van' : 'of'} {activeProgram.weeks}
          </div>
        </div>

        {/* Team overview (admin only) */}
        {isAdmin && progress.length > 0 && (
          <div style={{ background: _T.bg3, borderRadius: 12, padding: 14, marginBottom: 14, border: `1px solid ${_T.cardBorderBot}` }}>
            <div style={{ color: C.white, fontSize: 13, fontWeight: 600, marginBottom: 10 }}>
              {nl ? 'Teamvoortgang' : 'Team Progress'}
            </div>
            {progress.map(p => {
              const pTasks = activeProgram.tasks?.reduce((s, w) => s + (w.items?.length || 0), 0) || 1;
              const pPct   = Math.round(((p.completed_tasks?.length || 0) / pTasks) * 100);
              return (
                <div key={p.user_id} style={{ marginBottom: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 2 }}>
                    <span style={{ color: C.silver }}>{p.name || p.user_id}</span>
                    <span style={{ color: _T.accent }}>W{p.week} · {pPct}%</span>
                  </div>
                  <div style={{ background: _T.bg4, borderRadius: 4, height: 5 }}>
                    <div style={{ width: `${pPct}%`, height: '100%', background: _T.accent, borderRadius: 4 }} />
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Tasks per week */}
        {tasks.map((weekData, wi) => {
          const isCurrentWeek = (wi + 1) === currentWeek;
          const isPastWeek    = (wi + 1) < currentWeek;
          return (
            <div key={wi} style={{ background: _T.bg3, borderRadius: 12, padding: 14, marginBottom: 10, border: `2px solid ${isCurrentWeek ? _T.accent : _T.cardBorderBot}`, opacity: isPastWeek ? 0.65 : 1 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <div style={{ color: C.white, fontSize: 14, fontWeight: 600 }}>{nl ? 'Week' : 'Week'} {weekData.week}</div>
                {isCurrentWeek && <span style={{ background: `${_T.accent}20`, color: _T.accent, padding: '3px 8px', borderRadius: 6, fontSize: 11, fontWeight: 600 }}>{nl ? 'Huidig' : 'Current'}</span>}
                {isPastWeek    && <span style={{ background: `#4AC87A18`, color: '#4AC87A', padding: '3px 8px', borderRadius: 6, fontSize: 11 }}>{nl ? 'Klaar' : 'Done'}</span>}
              </div>
              {(weekData.items || []).map((task, ti) => {
                const key    = `${wi}-${ti}`;
                const isDone = completed.includes(key);
                return (
                  <button key={ti} onClick={() => handleTaskClick(wi, ti, task)}
                    style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', background: 'none', border: 'none', padding: '9px 0', cursor: 'pointer', borderBottom: ti < (weekData.items?.length || 0) - 1 ? `1px solid ${_T.cardBorderBot}` : 'none', textAlign: 'left' }}>
                    <div style={{ width: 22, height: 22, borderRadius: 6, border: `2px solid ${isDone ? '#4AC87A' : _T.cardBorderBot}`, background: isDone ? '#4AC87A' : _T.bg4, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'all 0.2s' }}>
                      {isDone && <span style={{ color: '#0a1220', fontSize: 12, fontWeight: 700 }}>✓</span>}
                    </div>
                    <span style={{ fontSize: 13, color: isDone ? C.silver2 : C.white, textDecoration: isDone ? 'line-through' : 'none', flex: 1 }}>{task}</span>
                    {!isDone && (
                      <span style={{ fontSize: 10, color: C.silver2, flexShrink: 0 }}>
                        {detectExercise(task).icon}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          );
        })}

        {currentWeek < activeProgram.weeks && (
          <button onClick={advanceWeek}
            style={{ width: '100%', padding: 14, background: 'linear-gradient(135deg,#4AC87A,#2fa85f)', color: '#0a1220', border: 'none', borderRadius: 12, fontSize: 14, fontWeight: 700, cursor: 'pointer', marginTop: 8 }}>
            {nl ? `Week ${currentWeek} afronden →` : `Complete Week ${currentWeek} →`}
          </button>
        )}
        {currentWeek === activeProgram.weeks && (
          <div style={{ textAlign: 'center', padding: 16, color: '#4AC87A', fontWeight: 600, fontSize: 16 }}>
            🎉 {nl ? 'Programma afgerond! Goed gedaan!' : 'Program complete! Great work!'}
          </div>
        )}

        {/* Mini exercise modal (portal) */}
        {miniExModal && (
          <MiniExerciseModal
            exercise={miniExModal.exercise}
            taskText={miniExModal.task}
            nl={nl}
            onComplete={completeMiniExercise}
            onCancel={() => setMiniExModal(null)}
          />
        )}
      </div>
    );
  }

  // ── Program list ──────────────────────────────────────────────────────────────
  return (
    <div style={{ padding: '0 0 32px' }}>
      <style>{CSS}</style>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div>
          <div style={{ color: C.white, fontSize: 17, fontWeight: 700 }}>{nl ? "Welzijnsprogramma's" : 'Wellness Programs'}</div>
          <div style={{ color: C.silver, fontSize: 12, marginTop: 2 }}>{nl ? "8-weken programma's voor je team" : '8-week programs for your team'}</div>
        </div>
        {isAdmin && (
          <button onClick={() => setShowTemplates(!showTemplates)}
            style={{ background: `${_T.accent}20`, border: `1px solid ${_T.accent}55`, borderRadius: 10, color: _T.accent, fontSize: 13, fontWeight: 600, padding: '8px 14px', cursor: 'pointer' }}>
            + {nl ? 'Toevoegen' : 'Add'}
          </button>
        )}
      </div>

      {/* Template picker */}
      {showTemplates && (
        <div style={{ background: _T.bg3, borderRadius: 14, padding: 14, marginBottom: 16, border: `1px solid ${_T.cardBorderBot}` }}>
          <div style={{ color: C.white, fontSize: 13, fontWeight: 600, marginBottom: 10 }}>
            {nl ? 'Kies een sjabloon' : 'Choose a template'}
          </div>
          {BASE_PROGRAMS.map((tpl, i) => (
            <button key={i} onClick={() => createFromTemplate(tpl)}
              style={{ display: 'block', width: '100%', textAlign: 'left', background: _T.bg4, border: `1px solid ${_T.cardBorderBot}`, borderRadius: 10, padding: 12, marginBottom: 8, cursor: 'pointer' }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: C.white }}>{nl ? tpl.title.nl : tpl.title.en}</div>
              <div style={{ fontSize: 12, color: C.silver, marginTop: 2 }}>{nl ? tpl.description.nl : tpl.description.en}</div>
            </button>
          ))}
        </div>
      )}

      {programs.length === 0 ? (
        <div style={{ textAlign: 'center', color: C.silver, padding: 48 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🏃</div>
          <div style={{ fontSize: 15, marginBottom: 4 }}>{nl ? "Nog geen programma's" : 'No programs yet'}</div>
          {isAdmin && <div style={{ fontSize: 13, color: C.silver2 }}>{nl ? 'Voeg een sjabloon toe om te beginnen' : 'Add a template to get started'}</div>}
        </div>
      ) : (
        programs.map(prog => (
          <div key={prog.id} style={{ background: _T.bg3, borderRadius: 14, padding: 16, marginBottom: 10, border: `1px solid ${_T.cardBorderBot}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: C.white }}>{prog.title}</div>
                <div style={{ fontSize: 12, color: C.silver, marginTop: 2 }}>{prog.description}</div>
                <div style={{ fontSize: 12, color: _T.accent, marginTop: 4 }}>{prog.weeks} {nl ? 'weken' : 'weeks'}</div>
              </div>
              {isAdmin && (
                <button onClick={() => deleteProgram(prog.id)}
                  style={{ background: 'none', border: 'none', color: '#C05050', fontSize: 18, cursor: 'pointer', padding: 4 }}>×</button>
              )}
            </div>
            <button onClick={() => openProgram(prog)}
              style={{ marginTop: 12, width: '100%', padding: '11px 0', background: `linear-gradient(135deg,${_T.grad1},${_T.grad2})`, color: '#0a1220', border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="#0a1220"><polygon points="5,3 19,12 5,21"/></svg>
              {nl ? 'Starten' : 'Play'}
            </button>
          </div>
        ))
      )}
    </div>
  );
}
